import { AssetType } from "gql/types";
import { Translate } from "lib/i18n/client";

export const assetPath = (
  t: Translate,
  lang: string,
  options: { assetType: AssetType; slug: string },
): string =>
  `/${lang}/${t(`common:routes.asset.type.${options.assetType.toLowerCase()}`)}/${
    options.slug
  }`;

export const assetHelpPath: AssetRoute = (t, assetPath) => `${assetPath}/help`;

export const destinationTravelGuidePath = (
  t: Translate,
  destinationPath: string,
): string => `${destinationPath}/${t("common:routes.travelGuide")}`;

type AssetRoute = (t: Translate, assetPath: string) => string;
